import styled from 'styled-components';

export const Titulo = styled.h1`
  color: white;
`;
